/* 공용 통화 포맷 (2026-08-31 사장님 "파트너 앱 전면 개선" B단계)
 * 배경: 페이지마다 formatCurrency를 제각각 정의($1,234.56 / 1,234 KRW / 1,234 USDT / $raw 혼재).
 * 원칙: USDT는 소수 2자리 + ' USDT', 원화는 정수 + '원'. 손익은 부호 표기.
 * 손익 색상: 이익=빨강 / 손실=파랑 (국내 HTS 관례 — 회원·관리자 화면과 동일) */

export const fmtUsdt = (v: any, digits = 2): string => {
  const n = Number(v || 0)
  return `${n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })} USDT`
}

export const fmtKrw = (v: any): string => `${Math.round(Number(v || 0)).toLocaleString()}원`

export const fmtUsdtSigned = (v: any, digits = 2): string => {
  const n = Number(v || 0)
  return `${n > 0 ? '+' : ''}${fmtUsdt(n, digits)}`
}

export const fmtKrwSigned = (v: any): string => {
  const n = Number(v || 0)
  return `${n > 0 ? '+' : ''}${fmtKrw(n)}`
}

/** 행 통화에 따라 자동 (거래내역 병합 응답의 currency: 'KRW' | 'USDT') */
export const fmtByCurrency = (v: any, currency?: string, signed = false): string => {
  if (currency === 'KRW') return signed ? fmtKrwSigned(v) : fmtKrw(v)
  return signed ? fmtUsdtSigned(v) : fmtUsdt(v)
}

/** 손익 색상 클래스 — 이익 빨강/손실 파랑/0 회색 */
export const pnlClass = (v: any): string => {
  const n = Number(v || 0)
  return n > 0 ? 'text-red-400' : n < 0 ? 'text-blue-400' : 'text-dark-300'
}

/** null/undefined → '-' (NF 병합 행의 margin/leverage 등 빈 필드) */
export const orDash = (s: string | null | undefined): string => (s == null || s === '' ? '-' : s)
